var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c(
        "w-card-content",
        [
          _vm._v(" Weet u zeker dat u de volgende files wilt versturen? "),
          _c(
            "div",
            _vm._l(_vm.other, function (file) {
              return _c("span", { key: file }, [_vm._v(_vm._s(file) + " ")])
            }),
            0
          ),
          _vm._l(_vm.images, function (img) {
            return _c("div", { key: img }, [
              _c("img", {
                staticClass: "img",
                attrs: { src: img, alt: "image" },
              }),
            ])
          }),
        ],
        2
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "danger",
              attrs: { disabled: _vm.confirmed },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v("Nee")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: _vm.confirmed },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v("Ja")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }